import type { TicketActivityItem } from "./ticket-presentation";

export type TicketEventItem = Extract<TicketActivityItem, { kind: "event" }>;
export type TicketEventGroup = { kind: "event-group"; id: string; events: TicketEventItem[] };
export type TicketActivityRow = TicketActivityItem | TicketEventGroup;

const MaxEventGroupSize = 4;

/** 只收起连续的普通操作；消息和含解决结果的记录始终独立可见。 */
export function groupTicketActivities(activities: readonly TicketActivityItem[]): TicketActivityRow[] {
  const rows: TicketActivityRow[] = [];
  let events: TicketEventItem[] = [];

  const flushEvents = () => {
    const firstEvent = events[0];
    if (firstEvent && events.length >= MaxEventGroupSize) rows.push({ kind: "event-group", id: firstEvent.id, events });
    else rows.push(...events);
    events = [];
  };

  for (const activity of activities) {
    if (activity.kind === "event" && !activity.resolution) {
      events.push(activity);
    } else {
      flushEvents();
      rows.push(activity);
    }
  }
  flushEvents();

  return rows;
}
